import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { MetricsTestimonialsSection } from './components/MetricsTestimonialsSection';
import { ExtendedTestimonialsSection } from './components/ExtendedTestimonialsSection';
import { PainSection } from './components/PainSection';
import { TransitionHookSection } from './components/TransitionHookSection';
import { ProductIntroSection } from './components/ProductIntroSection';
import { ProductShowcaseSection } from './components/ProductShowcaseSection';
import { ModulesSection } from './components/ModulesSection';
import { VipModuleSection } from './components/VipModuleSection';
import { BonusesSection } from './components/BonusesSection';
import { UrgencySection } from './components/UrgencySection';
import { PriceSection } from './components/PriceSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { ComparisonSection } from './components/ComparisonSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { FooterSection } from './components/FooterSection';
import { SocialProofPopup } from './components/SocialProofPopup';
const META_PIXEL_ID = '1313291250496067';
export function App() {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;700&family=Fraunces:opsz,wght@9..144,700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    // Evita que el efecto se ejecute dos veces (StrictMode / remounts / HMR)
    if (w.__mpPixelLoaded) return;
    w.__mpPixelLoaded = true;
    // Inicializa el stub de fbq y carga fbevents.js una sola vez
    if (!w.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      w.fbq = n;
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      w.fbq('init', META_PIXEL_ID);
    }
    // Registra UNA sola vista de página por sesión de pestaña.
    // sessionStorage sobrevive a remounts y recargas del editor, evitando dobles PageView.
    try {
      if (!sessionStorage.getItem('mp_pv_sent')) {
        sessionStorage.setItem('mp_pv_sent', '1');
        w.fbq('track', 'PageView');
      }
    } catch {
      w.fbq('track', 'PageView');
    }
  }, []);
  return <div className="font-sans text-white bg-familia-bg min-h-screen selection:bg-familia-cyan selection:text-familia-bg" data-id="element-0">
      {/* Meta Pixel — fallback sin JavaScript */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" />
      </noscript>
      <SocialProofPopup data-id="element-3" />
      <HeroSection data-id="element-4" />
      <MetricsTestimonialsSection data-id="element-5" />
      <ExtendedTestimonialsSection isInitial={true} data-id="element-6" />
      <PainSection data-id="element-7" />
      <TransitionHookSection data-id="element-8" />
      <ProductIntroSection data-id="element-9" />
      <ProductShowcaseSection data-id="element-10" />
      <ModulesSection data-id="element-11" />
      <VipModuleSection data-id="element-12" />
      <BonusesSection data-id="element-13" />
      <UrgencySection data-id="element-14" />
      <PriceSection data-id="element-15" />
      <ExtendedTestimonialsSection data-id="element-16" />
      <GuaranteeSection data-id="element-17" />
      <FaqSection data-id="element-18" />
      <ComparisonSection data-id="element-19" />
      <FinalCtaSection data-id="element-20" />
      <FooterSection data-id="element-21" />
    </div>;
}